import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { addLocationType, updateLocationType } from '../../actions/userActions/locationTypeAction';
import Loader from '../subComponents/Loader'
import { Redirect, useLocation, useHistory } from 'react-router-dom';
import BodyExtraSmallMedium from '../designSystem/BodyExtraSmallMedium';
import Textarea from '../designSystem/TextArea';
import TextField from '../designSystem/TextField';
import { IconButton } from '@mui/material';
import locationtypeicon from "../../assets/images/locationtypeicon.svg";
import closeModal from "../../assets/images/closeModal.svg";
import BodyLargeMedium from '../designSystem/BodyLargeMedium';
import { validateFields } from '../../utils/Validations';
import { Check, X } from 'lucide-react';
import CancelButton from '../subComponents/buttons/CustomCancelButton';
import PrimaryButton from '../subComponents/buttons/PrimaryButton';
import LoadingOverlay from '../loadingOverlay/LoadingOverlay';
function AddLocationTypes({ onClose, editData, onSave }) {

  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const initialValues = { name: "", description: "" };
  const [formValues, setFormValues] = useState(initialValues);
  const [formErrors, setFormErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const handletextChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };
  useEffect(() => {
    if (editData) {
      setFormValues(editData);
    }
  }, [editData]);

  const handleSave = async (e) => {
    e.preventDefault();
    const errors = validateFields(formValues, 'locationtype');
    setFormErrors(errors);
    if (Object.keys(errors).length > 0) return;
    setLoading(true);
    try {
      if (editData) {
        await dispatch(updateLocationType(formValues));
      } else {
        await dispatch(addLocationType(formValues));
      }
      setLoading(false);
      await onSave(formValues);
    } catch (error) {
      setLoading(false);
    }
  };
  return (
    <>
      <div className="dynamicmodal-overlay">
        <div className="dynamicmodal-container overlay-wrapper">
          <LoadingOverlay isVisible={loading} />
          <div className={loading ? 'blur' : ''}>
          <div className="dynamicmodal-header mb-3">
            <div className="dynamicmodal-header-left">
              <div className="icon">
                <img src={locationtypeicon} alt="locationtypeicon" />
              </div>
              <div className="text">
                <h2 className="modalheading">
                  {editData ? "Edit PracticeLocation Type" : "Add PracticeLocation Type"}
                </h2>
                <p className="modaldescription">
                  Set a new type of practice location.
                </p>
              </div>
            </div>
            <div className="dynamicmodal-header-right">
              <IconButton onClick={onClose}>
                <img src={closeModal} alt="" />
              </IconButton>
            </div>
          </div>


          <form onSubmit={handleSave}>
            <div className="dynamicmodal-body">

              <TextField
                name="name"
                label="Name"
                type='text'
                value={formValues.name}
                onChange={handletextChange}
                placeholder='Enter name'
                error={formErrors.name}
              />

              <Textarea
                name="description"
                label="Description"
                placeholder="Enter description here"
                value={formValues.description}
                onChange={handletextChange}
                error={formErrors.description}
              />
            </div>

            <div className="dynamicmodal-footer">
             <CancelButton
              onClick={onClose}
              text="Cancel"
              />
              <PrimaryButton
              text="Save"
              icon={Check}
              />
            </div>
          </form>
          </div>
        </div>
      </div>
    </>
  )
}

export default AddLocationTypes
